<template>
	<div class="page">
		<div class="page-inner centered-content">
			<h3>Oops! There was an error</h3>
			<h3>Your session may have expired</h3>
			<a href="/">Restart your journey</a>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	props: {},
	mixins: [],
	data() {
		return {};
	},
	created() {},
	methods: {}
};
</script>

<style scoped>
.page-inner {
	height:100vh;
	display:flex;
	justify-content:center;
	align-items:center;
	flex-direction: column;
}

a {
    text-decoration: underline;
    font-size: 1.5rem;
    margin-top: 2rem;
}
</style>
